module.exports = __webpack_public_path__ + "img/arrow_drop_down.d952fb62.svg";